var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInk = function SvgInk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.12323e-17 -1 1 6.12323e-17 0 512)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M507.604,131.729L380.271,4.396c-5.861-5.861-15.358-5.861-21.22,0l-67.661,67.661c-5.861,5.861-5.861,15.358,0,21.22    L418.723,220.61c2.93,2.931,6.77,4.397,10.609,4.397s7.679-1.466,10.61-4.397l67.661-67.661    C513.466,147.087,513.466,137.59,507.604,131.729z",
    "data-original": "#000000",
    className: "active-path",
    style: {
      fill: "#C4852E"
    },
    "data-old_color": "#000000"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M397.504,241.829L270.171,114.497c-0.187-0.187-0.313-0.416-0.496-0.604l-143.542,71.767    c-3.282,1.642-5.861,4.44-7.225,7.855L0,490.78l182.374-182.374c-2.808-5.869-4.512-12.357-4.512-19.287    c0-24.824,20.194-45.019,45.019-45.019s45.019,20.194,45.019,45.019c0,24.824-20.194,45.019-45.019,45.019    c-6.93,0-13.418-1.704-19.287-4.512L21.22,512l297.267-118.906c3.414-1.363,6.214-3.942,7.855-7.225l71.767-143.542    C397.92,242.144,397.691,242.017,397.504,241.829z",
    "data-original": "#000000",
    className: "active-path",
    style: {
      fill: "#C4852E"
    },
    "data-old_color": "#000000"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M222.88,274.114c-8.279,0-15.006,6.727-15.006,15.006c0,8.279,6.727,15.006,15.006,15.006    c8.279,0,15.006-6.727,15.006-15.006C237.886,280.841,231.16,274.114,222.88,274.114z",
    "data-original": "#000000",
    className: "active-path",
    style: {
      fill: "#C4852E"
    },
    "data-old_color": "#000000"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ink.2fa177b7.svg";
export { ForwardRef as ReactComponent };